import { getAssetClass } from "./urlHelpers";

export const notAssetClass = ["Home", "Topics", "topics", "Analyst"];

// TODO replace requests with CompanyWithTicker to companies.nameWithTicker.en directly
export const getAssetClassFilters = (qs) => {
  const category = getAssetClass(qs);
  if (notAssetClass.includes(category)) return {};

  return { "txCategories.en": category };
};

export const getFeaturedReportFilters = () => ({ "customData.featured": true });

export const getTermFilters = (_qs, pubLang) => {
  let qs = { ..._qs }; // clone

  // autocomplete categories must be mapped to real fields
  qs = mapKeyToField(qs, "CompanyWithTicker", "companies.nameWithTicker.en");
  qs = mapKeyToField(qs, "CompanyWithTicker-JA", "companies.nameWithTicker.ja");
  qs = mapKeyToField(qs, "Analyst", "analysts.name.en");
  qs = mapKeyToField(qs, "Analyst-JA", "analysts.name.ja");
  qs = mapKeyToField(qs, "Report Titles", "reportTitles.en");
  qs = mapKeyToField(qs, "Report Titles-JA", "reportTitles.ja");
  qs = mapKeyToField(qs, "Theme", "themes.en");
  qs = mapKeyToField(qs, "Theme-JA", "themes.ja");
  qs = mapKeyToField(qs, "Trade Ideas", "tradeIdeas.en");
  qs = mapKeyToField(qs, "Trade Ideas-JA", "tradeIdeas.ja");

  // TODO are these mappings used?
  qs = mapKeyToField(qs, "regions", "regions.en"); // used by menu bar, sidebar
  qs = mapKeyToField(qs, "Region", "regions.en");
  qs = mapKeyToField(qs, "Region-JA", "regions.ja");
  qs = mapKeyToField(qs, "Country", "countries.en");
  qs = mapKeyToField(qs, "Country-JA", "countries.ja");
  qs = mapKeyToField(qs, "assetClasses", "assetClasses.en");
  qs = mapKeyToField(qs, "sectors", "gicsSectors.en");
  qs = mapKeyToField(qs, "reportTitles", "reportTitles.en");
  qs = mapKeyToField(qs, "assetTypes", "assetTypes.en");
  qs = mapKeyToField(qs, "teams", "teams.en");
  qs = mapKeyToField(qs, "analysts", "analysts.name.en");
  qs = mapKeyToField(qs, "companies", "companies.name.en");

  // dependencies from pub card pills
  qs = mapKeyToField(qs, "Asset Class", "assetClasses.en");
  qs = mapKeyToField(qs, "Asset Class-JA", "assetClasses.ja");
  qs = mapKeyToField(qs, "Regions", "regions.en");
  qs = mapKeyToField(qs, "Regions-JA", "regions.ja");

  if (qs.language || pubLang.length) {
    qs.language = qs.language || pubLang;
  }

  excludedKeys.forEach((key) => delete qs[key]);
  clearKeysWithEmptyValues(qs);
  return qs;
};

const mapKeyToField = (qs, key, field) => {
  if (qs[key]) {
    qs[field] = qs[key];
    delete qs[key];
  }
  return qs;
};

const clearKeysWithEmptyValues = (qs) => Object.keys(qs).forEach((key) => !qs[key] && delete qs[key]);

const excludedKeys = [
  "",
  "q",
  "title",
  "sort",
  "SortAsc",
  "SortDesc",
  "Date",
  "DateTo",
  "exclusions",
  "Language",
  "source",
  "es-index",
  "debug",
  "ads",
  "From",
  "Tab",
  "subscribe",
];
